/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PolicyDefaultExceptionCriteriaDimension {
    JOB_FAMILY = 'jobFamily',
    JOB_SUB_FAMILY = 'jobSubFamily',
    JOB_LEVEL = 'jobLevel',
    COMPANY_JOB = 'companyJob',
}
